import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '../../authApiService';
import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';

export const getExecutorPaymentDetailsApi = (wireId: string): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/executor/wires/${wireId}/payment-details/`;

  return authApiService.GET(uri);
};
